const ROUTES = {
  // AUTH
  LOGIN_SCREEN: '/auth/login',
  ROOT_SCREEN: '/',
  FORGOT_PASSWORD_SCREEN: '/auth/forgot-password',
  CONFIRMATION_SCREEN: '/auth/forgot-password-message',
  RESET_PASSWORD_SCREEN: '/auth/reset-password',
  RESET_CONFIRMATION_SCREEN: '/auth/reset-password-message',

  // PRIVATE ROUTES
  DASHBOARD: '/dashboard',

  // dashboard v2
  DASHBOARD_V2: '/dashboard-v2',
  VIEW_BATCH_AUDIT_SHEET: '/audit/sheet/batch/:batchId/view',
  BATCH_AUDIT_SHEET: '/audit/sheet/batch/:batchId',

  // ACCOUNT ROUTE
  ACCOUNT: '/account',

  AUDIT_SHEET: '/audit/sheet/:uploadId',
  VIEW_AUDIT_SHEET: '/audit/sheet/:uploadId/view',

  NOTIFICATIONS: '/client/notification',
  HELP: '/client/help',
  REDIRECT_LOGIN: '/redirect/login'
};

export default ROUTES;

export const PUBLIC_PATH = [
  ROUTES.LOGIN_SCREEN,
  // ROUTES.ROOT_SCREEN,
  ROUTES.FORGOT_PASSWORD_SCREEN,
  ROUTES.CONFIRMATION_SCREEN,
  ROUTES.RESET_PASSWORD_SCREEN,
  ROUTES.RESET_CONFIRMATION_SCREEN,
  ROUTES.REDIRECT_LOGIN
];
